module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (249).a5a7844f.jpg";